import React, { Dispatch, ReactElement, SetStateAction, useState } from 'react';
import { createContext, useContextSelector } from 'use-context-selector';
import { BoardState } from 'store/types/board';

const initialState: BoardState = {
  grid: [],
  hoverIndexes: [],
  isRunning: false,
  iterationDone: true,
  isPlacingSeed: false,
  isEditingGrid: true,
  numOfRows: 50,
  numOfCols: 80,
};

const BoardContext = createContext<{
  state: BoardState;
  setState: Dispatch<SetStateAction<BoardState>>;
}>({
  state: initialState,
  setState: () => null,
});

const useBoardStateSelector = (): BoardState =>
  useContextSelector(BoardContext, context => context.state);

interface Props {
  children: ReactElement;
}

const BoardContextProvider = (props: Props): ReactElement => {
  const [state, setState] = useState(initialState);
  return (
    <BoardContext.Provider value={{ state, setState }}>
      {props.children}
    </BoardContext.Provider>
  );
};

export { BoardContext, useBoardStateSelector, BoardContextProvider };
